var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17.312,
    viewBox: "0 0 21.639 17.312",
    width: 21.639,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m62.815 28.856v15.144a1.08 1.08 0 0 1 -1.091 1.083 1.066 1.066 0 0 1 -.758-.317l-4.009-4.011h-4.6a1.083 1.083 0 0 1 -1.083-1.083v-6.49a1.082 1.082 0 0 1 1.083-1.082h4.6l4.009-4.011a1.062 1.062 0 0 1 .758-.317 1.08 1.08 0 0 1 1.091 1.084zm-1.443.871-3.818 3.816h-4.837v5.771h4.838l3.818 3.816zm7.213 6.7a3.141 3.141 0 0 1 -1.85 2.814.721.721 0 1 1 -.625-1.3 1.626 1.626 0 0 0 0-3.028.721.721 0 1 1 .625-1.3 3.139 3.139 0 0 1 1.851 2.816zm.323 7.117a.731.731 0 0 1 -.993-.265.722.722 0 0 1 .267-.987 6.89 6.89 0 0 0 0-11.731.722.722 0 0 1 -.267-.987.732.732 0 0 1 .993-.264 8.326 8.326 0 0 1 0 14.234z",
    transform: "translate(-51.274 -27.773)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeaker);
export default __webpack_public_path__ + "static/media/icon-speaker.09bc302d6485fbe0961a47c75bf35859.svg";
export { ForwardRef as ReactComponent };